import React from "react";
import { Droppable } from "react-beautiful-dnd";
import styled from "styled-components";
import Task from "./Task";
import { cores } from "../styles/styleUtils";
import "./scroll.css";


const Container = styled.div`
  background-color: ${cores.branco};
  border-radius: 10px;
  border: 0.5px solid #E2E4E8;
  width: 300px;
  height: 90vh;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 52px;
  padding: 8px 14px;
  background-color: ${cores.cinzaClaro};
  position: sticky;
  top: 0;
  z-index: 1;
`;

const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => props.cor || cores.cinzaMedio};
  flex-shrink: 0;
`;

const TitleText = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${cores.chumbo};
`;

const Count = styled.span`
  margin-left: auto;
  background-color: ${cores.cinzaMedio};
  color: ${cores.branco};
  font-size: 12px;
  font-weight: 500;
  border-radius: 10px;
  padding: 1px 8px;
`;

const TaskList = styled.div`
  padding: 8px;
  transition: background-color 0.2s ease;
  background-color: ${cores.branco};
  flex-grow: 1;
  min-height: 100px;
`;

export default function Column({ title, tasks, id, columnColor, onConfirm }) {
  return (
    <Container className="column">
      <Title>
        <Dot cor={columnColor} />
        <TitleText>{title}</TitleText>
        <Count>{tasks?.length || 0}</Count>
      </Title>
      <Droppable droppableId={id}>
        {(provided, snapshot) => (
          <TaskList
            ref={provided.innerRef}
            {...provided.droppableProps}
            style={{
                backgroundColor: snapshot.isDraggingOver ? cores.cinzaClaro : cores.branco,
              }}
          >
            {tasks?.map((task, index) => (
              <Task key={index} index={index} task={task} columnColor={columnColor} onConfirm={onConfirm}/>
            ))}
            {provided.placeholder}
          </TaskList>
        )}
      </Droppable>
    </Container>
  );
}